<template>
  <div class="login">
    <!--   login abschnitt -->
    <v-card
      id="idLoginDialog"
      class="mx-auto"
      persistent
      max-width="600px"
      min-width="300px"
    >
      <div>
        <v-tabs
          v-model="tab"
          show-arrows
          background-color="primary"
          icons-and-text
          dark
          grow
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab v-for="i in tabs" :key="i.name" :to="i.to">
            <v-icon large>{{ i.icon }}</v-icon>
            <div class="caption py-1">{{ i.name }}</div>
          </v-tab>
          <v-tab-item>
            <v-card class="px-4">
              <v-card-text>
                <v-form ref="LoginForm" v-model="validForm" lazy-validation>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        id="login_Email"
                        name="login_Email"
                        ref="loginEmail"
                        autocomplete="username"
                        v-model="loginEmail"
                        :rules="loginEmailRules"
                        label="E-Mail"
                        prepend-icon="mdi-email"
                        v-on:keyup.enter="$refs.loginPW.focus()"
                        clearable
                        required
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        id="login_Password"
                        name="login_Password"
                        ref="loginPW"
                        autocomplete="current-password"
                        v-model="loginPassword"
                        :append-icon="pw_angezeigt ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[rules.required]"
                        :type="pw_angezeigt ? 'text' : 'password'"
                        label="Passwort"
                        prepend-icon="mdi-key"
                        clearable
                        hint=""
                        counter
                        v-on:keyup.enter="loginCall"
                        @click:append="pw_angezeigt = !pw_angezeigt"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col class="d-flex" cols="12" sm="6" xsm="12"> </v-col>
                    <v-spacer></v-spacer>
                    <v-col class="d-flex" cols="12" sm="3" xsm="12" align-end>
                      <v-btn
                        id="login_submit"
                        ref="loginSubmit"
                        x-large
                        block
                        :disabled="!validForm"
                        color="primary"
                        @click="loginCall"
                        >LOGIN
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item> </v-tab-item>
        </v-tabs>
      </div>
    </v-card>
    <!--   login abschnitt -->
  </div>
</template>

<style scoped></style>

<script>
import SettingsStore from "../store/SettingsStore";
export default {
  components: {},
  data: () => ({
    tab: 0,
    tabs: [
      { name: "Login", icon: "mdi-account" },
      {
        name: "Passwort vergessen",
        to: "/pw-reset-request",
        icon: "mdi-lock-reset",
      },
    ],
    validForm: true,
    loginEmail: "",
    loginPassword: "",
    password: "",
    pw_vergleich: "",
    pw_angezeigt: false,
    loginEmailRules: [
      (v) => !!v || "Erforderlich",
      (v) => /.+@.+\..+/.test(v) || "E-mail muss gültig sein",
      //v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail muss gültig sein'
    ],
    rules: {
      required: (value) => !!value || "Erforderlich.",
      min: (v) => (v && v.length >= 12) || "Mindestens 12 Zeichen",
      lowercase: (v) => /[a-z]/.test(v) || "Mindestens ein Kleinbuchstabe",
      uppercase: (v) => /[A-Z]/.test(v) || "Mindestens ein Grossbuchstabe",
      special: (v) =>
        /[!@#$%^&*)(+=._-]/.test(v) || "Mindestens ein Sonderzeichen",
    },
    snackbar: {},
  }),
  beforeMount() {},
  mounted() {
    this.loginEmail = this.$route.query.email ?? "";
    this.$refs.loginEmail.focus();
  },
  computed: {
    passwordMatch() {
      return () =>
        this.password === this.pw_vergleich ||
        "Passwörter müssen identisch sein";
    },
    mieter_oid: function () {
      return this.$store.state.mieter_oid;
    },
    mieter: function () {
      return this.$store.state.mieter;
    },
    token: function () {
      return this.$store.state.token;
    },
  },

  methods: {
    loginCall() {
      if (this.$refs.LoginForm.validate()) {
        // Jetzt können wir die Daten losschicken....oder was machen...
        this.$emit("loadingEvent", { text: "Login", show: true });

        // var url     =  SettingsStore.data.config.apiBaseURL + "/login" //wo das backende login sitzt
        var url = SettingsStore.data.config.apiBaseURL + "/login";

        //ORAG-306
        this.loginEmail = this.loginEmail.trim();
        this.loginPassword = this.loginPassword.trim();

        var data = {
          loginEmail: this.loginEmail,
          loginPassword: this.loginPassword,
        };
        var headers = {
          "Content-type": "application/json",
          Accept: "application/json",
        };
        var config = { timeout: 30000 };

        this.axios
          .post(url, data, headers, config)
          .then((response) => {
            this.$emit("loadingEvent", { show: false });
            //   console.log(response.data)
            if (response.data.result.success) {
              this.$store.commit("setMieterOid", response.data.data.mieter_oid);
              this.$store.commit("setToken", response.data.data.token);
              this.$store.commit(
                "setLoginName",
                response.data.data.mieter_name
              );
              this.$store.commit(
                "setLoginSalutation",
                response.data.data.mieter_salutation
              );
              this.$store.commit("setLoginEmail", this.loginEmail);
              var tempMieter = this.mieter;
              tempMieter.mobilnummer =
                response.data.data.mieter_mobil === null
                  ? ""
                  : response.data.data.mieter_mobil;
              tempMieter.telefonnummer =
                response.data.data.mieter_tel === null
                  ? ""
                  : response.data.data.mieter_tel;
              tempMieter.nachname =
                response.data.data.mieter_nachname === null
                  ? ""
                  : response.data.data.mieter_nachname;
              tempMieter.vorname =
                response.data.data.mieter_vorname === null
                  ? ""
                  : response.data.data.mieter_vorname;
              tempMieter.titel_pre =
                response.data.data.mieter_titel_pre === null
                  ? ""
                  : response.data.data.mieter_titel_pre;
              tempMieter.titel_post =
                response.data.data.mieter_titel_post === null
                  ? ""
                  : response.data.data.mieter_titel_post;
              this.$store.commit("setMieter", tempMieter);
              if (this.token != null) {
                if (this.$route.params.nextUrl != null) {
                  this.$router.push(this.$route.params.nextUrl);
                } else {
                  this.$router.push({ name: "VertragsObjekte" });
                }
              }
            } else {
              this.snackbar = {
                text: response.data.result.statustext,
                color: "error",
                show: true,
                timeout: 15000,
              };
              this.$emit("snackbarEvent", this.snackbar);
            }
          })
          .catch((error) => {
            this.$emit("loadingEvent", { show: false });
            console.log(error.response);
            let statustext =
              error.response.data.result.statustext ||
              "Das System konnte Sie nicht einloggen!<br/> Überprüfen Sie die Internetverbindung und die eingegebenen Daten und versuchen Sie es erneut.<br/>";
            this.snackbar = {
              text: statustext,
              color: "#B22222",
              show: true,
              timeout: 10000,
            };
            this.$emit("snackbarEvent", this.snackbar);
          });
      }
    },
  },
};
</script>
